document.addEventListener('DOMContentLoaded', function() {

    /** site footer Animation */
       if (window.location.href.indexOf('/cart') > -1) {
        // The script will stop here if it detects the cart page.
        return;
    }


/** Home Page Collection Grid */
    const productImages = document.querySelectorAll('.home-featured .grid.grid--uniform .grid-product__image-mask image-element');
    // Initialize the starting delay for the first image.
    let delay = 0;
    const delayIncrement = 150; // The amount to increase the delay for each subsequent image.

    // Loop through each of the selected image elements.
    productImages.forEach(image => {
        // Set the core AOS attributes for the animation effect.
        image.setAttribute('data-aos', 'zoom-out');
        image.setAttribute('data-aos-easing', 'ease');
        image.setAttribute('data-aos-duration', '1000');
        image.setAttribute('data-aos-anchor-placement','top-bottom')


        // Set the unique delay attribute for each image.
        image.setAttribute('data-aos-delay', delay);

        // Increment the delay for the next image in the sequence.
        delay += delayIncrement;
    });

/** Home Page Cards */
    const whyOrderCards = document.querySelectorAll('body.template-index .main-content .why-order-section-new .why-order-card');
    // Initialize the starting delay for the first image.
    let delayCard = 300;
    const delayIncrementCard = 150; // The amount to increase the delay for each subsequent image.

    // Loop through each of the selected image elements.
  whyOrderCards.forEach(card => {
        // Set the core AOS attributes for the animation effect.
       card.setAttribute('data-aos', 'fade-left');
   
        // Set the unique delay attribute for each image.
       card.setAttribute('data-aos-delay', delayCard);
       card.setAttribute('data-aos-anchor-placement','top-bottom');

        // Increment the delay for the next image in the sequence.
        delayCard += delayIncrementCard;
    });

/** Home Page  Shop  by stage*/
    const shopByStageCards = document.querySelectorAll('.shop-by-stage__grid .shop-by-stage__item');
    // Initialize the starting delay for the first image.
    let delayShopCardDelay = 450;
    const delayIncrementShopStages = 150; // The amount to increase the delay for each subsequent image.

    // Loop through each of the selected image elements.
shopByStageCards.forEach(shopcard => {
        // Set the core AOS attributes for the animation effect.
       shopcard.setAttribute('data-aos', 'fade-right');
        shopcard.setAttribute('data-aos-anchor-placement','top-bottom')
        // Set the unique delay attribute for each image.
       shopcard.setAttribute('data-aos-delay', delayShopCardDelay);

        // Increment the delay for the next image in the sequence.
        delayShopCardDelay  += delayIncrementShopStages;
    });


let okendoHeading = document.querySelector('.oke-reviewCarousel-header-title.oke-title');
if(okendoHeading){ okendoHeading.setAttribute ('data-aos', 'fade-up') ; okendoHeading.setAttribute ('data-aos-delay','150');okendoHeading.setAttribute('data-aos-anchor-placement','top-bottom');}

/** shop by stage grid  */

/** Home Page  Shop  by Categor*/
    const shopByCategory = document.querySelectorAll('.shop-by-category__grid .shop-by-category__image-wrapper');
    const shopByCategoryName = document.querySelectorAll('.shop-by-category__grid .shop-by-category__title')

    // Initialize the starting delay for the first image.
    let delayShopCategory= 0;
    const delayIncrementShopCategory = 150; // The amount to increase the delay for each subsequent image.

    // Loop through each of the selected image elements.
shopByCategory.forEach(categoryCard => {
        // Set the core AOS attributes for the animation effect.
      categoryCard.setAttribute('data-aos', 'flip-right');
      categoryCard.setAttribute('data-aos-anchor-placement','top-bottom')
 
        // Set the unique delay attribute for each image.
    categoryCard.setAttribute('data-aos-delay',  delayIncrementShopCategory );
  
      shopByCategoryName.forEach(item =>{
           item.setAttribute('data-aos', 'fade-up');
           item.setAttribute('data-aos-anchor-placement','top-bottom')
        // Set the unique delay attribute for each image.
item.setAttribute('data-aos-delay',  delayIncrementShopCategory );
      })

           

        // Increment the delay for the next image in the sequence.
        delayShopCardDelay  += delayIncrementShopStages;
    });

/** Why order new cards */
   const euBabyFormula = document.querySelectorAll('body.template-index .main-content .shopify-section:nth-child(12) .why-order-card');
    // Initialize the starting delay for the first image.
    let whydelayCard = 0;
    const whydelayIncrementCard = 50; // The amount to increase the delay for each subsequent image.

    // Loop through each of the selected image elements.
 euBabyFormula .forEach(card => {
        // Set the core AOS attributes for the animation effect.
       card.setAttribute('data-aos', 'fade-left');
       card.setAttribute('data-aos-anchor-placement','top-bottom');
  
        // Set the unique delay attribute for each image.
       card.setAttribute('data-aos-delay', whydelayCard);

        // Increment the delay for the next image in the sequence.
       whydelayCard  +=  whydelayIncrementCard;
    });


/* Home Page Shop br Brands **/
let shopByBrandsLogos = document.querySelectorAll('.home-shop-by-brand .row-image .row-img__link')
if(shopByBrandsLogos){
    let delayTime = 300;
     const delayTimeIncrement = 150;
    shopByBrandsLogos.forEach(logoBox => {
        logoBox.setAttribute ('data-aos', 'zoom-in');
  
        logoBox.setAttribute ('data-aos-delay', delayTime);
        logoBox.setAttribute('data-aos-anchor-placement','top-bottom');

     // Increment the delay for the next image in the sequence.
    delayTime += delayTimeIncrement;

    } );
}

//              /** Section Four */
let sectionFour = document.querySelector('body.template-collection .european-baby-formula-brands');
if(sectionFour){
    /** brand grid  */
    brandGrid = sectionFour.querySelectorAll('.brand-grid .brand-single');
    let startTime = 250;
    let incrementTimer = 50
     brandGrid.forEach (item => {
        item.setAttribute('data-aos', 'fade-up')
        item.setAttribute('data-aos-delay', startTime)

        startTime += incrementTimer;

    })   
}

/** Section Five */
let SectionFive = document.querySelector('body.template-collection .the-different-baby-formula-we-carry')
if(SectionFive){

 let firstCard = SectionFive.querySelector('.content-card');
firstCard.setAttribute('data-aos', 'fade-up');
firstCard.setAttribute('data-aos-delay', 250);

let secondCard = SectionFive.querySelector('.content-card.second-card');
secondCard.setAttribute('data-aos', 'fade-up');
secondCard.setAttribute('data-aos-delay', 300);

   
}

/** Section Six*/
let SectionSix = document.querySelector('body.template-collection .home-shop-by-brand ~ .why-organic-baby-formula')
if(SectionSix){

    let stagesCard = SectionSix.querySelectorAll('.why-order-cards-wrapper .single-card')
    let startTime = 250;
    let incrementTimer = 50
   stagesCard.forEach (item => {
        item.setAttribute('data-aos', 'fade-up')
        item.setAttribute('data-aos-anchor-placement','top-bottom');

        item.setAttribute('data-aos-delay', startTime)

        startTime += incrementTimer;

    })   

}



 const drawer = document.getElementById('NavDrawer');
  const closeBtn = document.querySelector('.js-drawer-close');
  const overlay = document.querySelector('.drawer-overlay'); // If you add overlay
  
  closeBtn.addEventListener('click', function() {
    // Add closing class
    drawer.classList.add('drawer--is-closing');
    
    // Remove open class and overlay after transition
    setTimeout(function() {
      drawer.classList.remove('drawer--is-open', 'drawer--is-closing');
      if (overlay) overlay.classList.remove('drawer-overlay--visible');
    }, 400); // Match transition duration
  });
  
  // Optional: Close on overlay click
  if (overlay) {
    overlay.addEventListener('click', function() {
      closeBtn.click();
    });
  }

/* Remomve animationm from footer payment icon*/
let footerImageContainers = document.querySelectorAll('.site-footer image-element');

footerImageContainers.forEach(container => {
 
    container.removeAttribute('data-aos');
    container.removeAttribute('data-aos-offset');
    container.classList.remove('aos-init', 'aos-animate');
    // === 2. Target the Child <img> Tag (which has the redundant class) ===
    const imageTag = container.querySelector('img');

    if (imageTag) {
     
        imageTag.classList.remove('image-element'); 
        
    } else {
        console.log('Warning: No image tag found inside the container:', container);
    }
});


/** main Function ends heree */
});